import { useParams, Link } from 'react-router-dom';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { categories, getCategoryBySlug } from '@/mocks/categories';
import { getGamesByCategory } from '@/mocks/games';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const category = getCategoryBySlug(slug || '');
  const games = getGamesByCategory(slug || '');

  if (!category) {
    return (
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-20 text-center">
        <h1 className="text-2xl font-heading text-foreground-900 font-bold mb-4">分类未找到</h1>
        <Link to="/" className="text-primary-600 hover:text-primary-700 cursor-pointer">返回首页</Link>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6 py-8 md:py-12">
      <Breadcrumb
        items={[
          { label: '首页', href: '/' },
          { label: category.name },
        ]}
      />

      <div className="mb-8">
        <h1 className="font-heading text-2xl md:text-3xl text-foreground-900 font-bold mb-2">
          {category.name}
        </h1>
        <p className="text-sm text-foreground-500">{category.description}</p>
      </div>

      <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap ${
              cat.slug === slug
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-600 hover:bg-secondary-100 hover:text-secondary-800'
            }`}
          >
            {cat.name}
          </Link>
        ))}
      </div>

      {games.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {games.map((game) => (
            <Link
              key={game.id}
              to={`/article/${game.slug}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300/60 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={game.imageUrl}
                  alt={game.title}
                  title={game.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 right-3 flex items-center gap-1 px-2 py-1 bg-background-50/90 backdrop-blur-sm rounded-md text-xs font-medium text-foreground-700">
                  <i className="ri-star-fill text-primary-500 text-xs"></i>
                  {game.rating}
                </div>
              </div>
              <div className="p-4 flex flex-col gap-2 flex-1">
                <h3 className="font-heading text-base text-foreground-900 font-bold group-hover:text-primary-600 transition-colors line-clamp-1">
                  {game.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                  {game.description}
                </p>
                <div className="flex items-center gap-2 flex-wrap mt-auto pt-2">
                  {game.tags.slice(0, 3).map((tag) => (
                    <span
                      key={tag}
                      className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-md whitespace-nowrap"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </Link>
          ))}
        </div>
      ) : (
        <div className="text-center py-20">
          <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-100">
            <i className="ri-gamepad-line text-2xl text-foreground-400"></i>
          </div>
          <p className="text-foreground-500">该分类暂无游戏</p>
        </div>
      )}
    </div>
  );
}